module.exports = require("./ff-Adlm-SN.d.ts");